//STYLES
import styles from "./RightNavbar.module.scss";
import React, { useState, useEffect, useRef } from "react";
//HOOKS
import { useContext } from "react";

//ICONS , IMAGES
import { MdOutlineMenu } from "react-icons/md";

//Components
import MyProfile from "./Submenus/MyProfile";
import Support from "./Submenus/Support";

//IMG

import Axios from "../../_services/caller.service";
import NavContext from "../../context/NavContext";
import InfosConnexion from "../superAdmin/infos/InfosConnexion";
import ToggleThemeButton from "../UiComponents/ToggleThemeBtn/ToggleThemeButton";

const RightNavbar = ({ socket }) => {
  const { nav, setNav, superAdmin,supportTeam, user, userGroup, ownerId, setOwnerId } =
    useContext(NavContext);

  const [infosUser, setInfosUser] = useState([]);
  const [userType, setUserType] = useState("");
  const [userIsOwner, setUserIsOwner] = useState(false);
  const [ownerLink, setOwnerLink] = useState("");
  const [cabineAccess, setCabineAccess] = useState(true);
  const [inviteOwnerId, setInviteOwnerId] = useState("");

  useEffect(() => {
     // ⛔️ pas superAdmin / supportTeam → aucun appel API
  if (!superAdmin && !supportTeam) {
    return;
  }

    Axios.get(`/relationUser/${ownerId}`)
      .then((response) => {
        const data = response.data.data;

        
        setInfosUser(data.user);
        setOwnerLink(data.owner);
        setUserType(data.userType);
        setCabineAccess(data.userType !== "Aucun accès à une cabine");
      })
      .catch(() => {});
  }, [ownerId]);

  return (
    <div className={styles.container}>
      {/* CENTRE - InfosConnexion */}
      <div className={styles.center}>
        {cabineAccess && superAdmin && (
          <div className={styles.connexion_info}>
            <InfosConnexion
              infosUser={infosUser}
              setOwnerId={setOwnerId}
              userIsOwner={userIsOwner}
              inviteOwnerId={inviteOwnerId}
              ownerLink={ownerLink}
              ownerId={ownerId}
            />
          </div>
        )}
      </div>

      {/* DROITE - Env et Actions */}
      <div className={styles.right}>
        <div className={styles.envInfo}>
          {process.env.REACT_APP_API_URL.includes("localhost") && (
            <span>LOCALHOST</span>
          )}
          {process.env.REACT_APP_API_URL.includes("beta") && <span>BETA</span>}
        </div>

        <div className={styles.actions}>
          <ToggleThemeButton />
          <MyProfile />
        </div>
      </div>
    </div>
  );
};

export default RightNavbar;
